// test2052
(2052 && 0);
